import { useCallback, useEffect, useState } from 'react'
import { fallbackPinImageUrl, pinImageUrl } from './pinImage'

export function usePinMarkImg(pinId?: string | null) {
  const [src, setSrc] = useState(() => pinImageUrl(pinId))

  useEffect(() => {
    setSrc(pinImageUrl(pinId))
  }, [pinId])

  const onError = useCallback(() => {
    setSrc(prev => {
      const fallback = fallbackPinImageUrl()
      return prev === fallback ? prev : fallback
    })
  }, [])

  return { src, onError }
}
